<template>
<Upload 
	:headers="{
		'is-desensitization':'false'
	}"
	:action="url||'/pc/chainSpecialityStores/importEmployeeInformation'"
	:show-upload-list="showUploadList"
	:on-success="handleSuccess"
	:data="data"
	:before-upload="handleBeforeUpload"
	:on-remove="handleremove"
	ref="upload">
    <Button icon="ios-cloud-upload-outline" :loading="loading" :disabled="disabled">{{btnText||'点击上传'}}</Button>
</Upload>
</template>
<script>
export default {
	props:{
		btnText:String,
		url:String,
		disabled:{
			type:Boolean,
			default:false
		},
		data:{
			type:Object,
			default(){
				return {}
			}
		},
		showUploadList:{
			type:Boolean,
			default:false
		}
	},
	data () {
		return {
			loading:false
		}
	},
	methods:{
		handleSuccess (res,file){
			if(res.code==10000000){
				this.$emit('on-success',res);
			}else{
				this.alert(res.msg)
			}
			this.loading = false;
		},
		handleBeforeUpload () {
			this.loading = true;
			this.$refs.upload.clearFiles()
		},
		handleremove(file, fileList){
			this.$refs.upload.clearFiles();
			this.$emit('on-remove',fileList);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/UploadFile.vue